import 'core-js';
import React, { PureComponent } from 'react';
import QuizQuestion from './quizQuestion';

class Quiz extends PureComponent {

  constructor(props) {
    super(props);
    this.child = React.createRef();

    const nbQuestionsPage1 = this.props.labels.questions.length / 2;

    this.state = {
      currentPage: 1,
      currentAnswers: Array.from({ length: nbQuestionsPage1 }),
      showError: false,
      nbQuestionsPage1,
      buttonDisabled: true,
      reset: false,
    };

    this.clicNext = this.clicNext.bind(this);
    this.updateScore = this.updateScore.bind(this);
    this.clicCancel = this.clicCancel.bind(this);
  }

  renderOptions() {
    return this.props.labels.quiz.options.map((option, i) => (<span key={ i }>{ option }</span>));
  }

  updateScore(num, score) {
    const tmpAnswers = this.state.currentAnswers;
    tmpAnswers[num] = score;
    this.setState({ currentAnswers: tmpAnswers });
    if (!this.state.currentAnswers.includes(undefined)) {
      this.setState({ buttonDisabled: false });
      this.props.toggleNotif(false);
    }
  }

  /*
  acceptMethods = (childDoAlert) => {
    // Parent stores the method that the child passed
    this.childDoAlert = childDoAlert;
  };
  */

  renderQuestions() {
    const tmpQuestions = [...this.props.labels.questions];
    if (this.state.currentPage === 1) {
      tmpQuestions.splice(this.state.nbQuestionsPage1, tmpQuestions.length);
    } else {
      tmpQuestions.splice(0, this.state.nbQuestionsPage1);
    }
    return tmpQuestions.map(question => (<QuizQuestion
        ref={ this.child }
        key={ question.num }
        num={ question.num }
        question={ question.title }
        options={ this.props.labels.quiz.options }
        updateScore={ this.updateScore }
        // showError={ this.state.showError && this.state.currentAnswers[i] === undefined }
        showError={ this.state.showError }
        reset={ this.state.reset }
        // shareMethods={ this.acceptMethods }
        />
    ));
  }

  clicNext() {
    // Check answers
    // Verif page 1
    if (this.state.currentPage === 1) {
      if (this.state.currentAnswers.includes(undefined)) {
        this.setState({ showError: true });
        this.props.toggleNotif(true);
        return; // DEBUG TMP TODO
      }
      const tmpArr = Array.from({ length: this.props.labels.questions.length - this.state.nbQuestionsPage1 });
      const tmpArr2 = [];
      tmpArr2.push(...this.state.currentAnswers);
      tmpArr2.push(...tmpArr);
      this.setState({ currentAnswers: tmpArr2 });
    }
    // Verif page 2
    if (this.state.currentPage === 2) {
      if (this.state.currentAnswers.includes(undefined)) {
        this.setState({ showError: true });
        this.props.toggleNotif(true);
        return; // DEBUT TMP TODO
      }
    }
    if (this.state.currentPage === 1) {
      // Go page 2
      this.setState({ currentPage: 2, buttonDisabled: true, showError: false });
      window.scroll(0, 0);
    } else {
      // Display screen score
      const sum = this.state.currentAnswers.reduce((sum2, x) => sum2 + x);
      this.props.goResult(sum);
    }
  }

  clicCancel() {
    this.setState({ reset: true, buttonDisabled: true }, () => {
      this.setState({ reset: false });
    });
  }

  render() {
    return (
      <div className="quiz animated fadeIn">
        <div className="quiz-title">
          <div>{ this.props.labels.quiz.title }</div>
          <div className="quiz-options">
            { this.renderOptions() }
          </div>
        </div>
        <div>
          { this.renderQuestions() }
        </div>
        {/*
        <div className="quiz-pagination">
          <span>{ this.state.currentPage }</span>
          <span>/2</span>
        </div>
        */}
        <div style={{ marginTop: '20px' }}>
          <span><button onClick={ this.clicNext }><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" className="svg-inline--fa fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>{ this.state.currentPage === 1 ? this.props.labels.quiz.button_next : this.props.labels.quiz.button_result }</button></span>
          <span><a onClick={ this.clicCancel }>{ this.props.labels.quiz.button_cancel }</a></span>
        </div>
      </div>
    );
  }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/components/quiz.js